const TOKEN_KEY = 'yq_student_token'
const SIGN_SECRET_KEY = 'yq_student_sign_secret'
const STUDENT_KEY = 'yq_student_info'

export function setLoginInfo(data) {
  localStorage.setItem(TOKEN_KEY, data.token || '')
  localStorage.setItem(SIGN_SECRET_KEY, data.signSecret || '')
  localStorage.setItem(STUDENT_KEY, JSON.stringify(data.userDetailRes || {}))
}

export function getToken() {
  return localStorage.getItem(TOKEN_KEY)
}

export function getSignSecret() {
  return localStorage.getItem(SIGN_SECRET_KEY)
}

export function getStudent() {
  const raw = localStorage.getItem(STUDENT_KEY)
  if (!raw) return null
  try {
    return JSON.parse(raw)
  } catch (e) {
    return null
  }
}

export function setStudent(student) {
  localStorage.setItem(STUDENT_KEY, JSON.stringify(student || {}))
}

export function clearLoginInfo() {
  localStorage.removeItem(TOKEN_KEY)
  localStorage.removeItem(SIGN_SECRET_KEY)
  localStorage.removeItem(STUDENT_KEY)
}

export function isLoggedIn() {
  return !!getToken()
}
